<template>
  <div>
    <section class="common-image-uploader">
      <el-row v-if="imageObj.type === 'check' && !imageObj.fileList.length">
        <p v-if="!imageObj.isHidePageTitle" class="title_info">
          {{ imageObj.title }}
        </p>
        <div class="photo_icon">
          <img src="../../assets/images/console-common/didi_logo.svg" alt="" />
        </div>
      </el-row>
      <div v-else>
        <p v-if="!imageObj.isHidePageTitle" class="title_info">
          {{ imageObj.title }}
        </p>
        <el-upload
          :action="url"
          :multiple="true"
          list-type="picture-card"
          :on-preview="handlePictureCardPreview"
          :before-upload="beforeUpload"
          :limit="imageObj.limit"
          :on-success="handleSuccessPicture"
          :file-list="imageList"
          :on-exceed="exceed"
          ref="uploader"
          :disabled="imageObj.disabled || false"
          :accept="accept"
          :on-remove="handleRemove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog
          :visible.sync="isShowCheckPhotoDialog"
          :append-to-body="true"
        >
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
        <p
          v-if="imageObj.type !== 'check'"
          class="common-image-uploader_bottom_info"
        >
          支持{{ acceptInfo }}格式，最多可上传{{ imageObj.limit }}张
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import eventBus from '../../utils/fresh-table'
export default {
  created() {
    if (this.imageObj.fileList.length) {
      this.imageList = this.imageObj.fileList
      this.imageObj.fileList.forEach((item) => {
        this.uploadKeys.push(item.uploadKey)
      })
    }
  },
  mounted() {
    if (this.imageObj.type === 'check') {
      // 查看不能编辑
      if (this.imageObj.fileList.length) {
        this.$refs.uploader.$children[1].$el.style = 'display:none'
      }
    } else {
      if (this.imageObj.fileList.length >= this.imageObj.limit) {
        this.$refs.uploader.$children[1].$el.style = 'display:none'
      }
    }
    eventBus.$on('removeImage', () => {
      if (this.$refs.uploader) {
        this.$refs.uploader.clearFiles()
        this.uploadKeys = []
        this.$refs.uploader.$children[1].$el.style = 'display:inline-block'
      }
    })
  },
  data() {
    return {
      dialogImageUrl: '',
      uploadKeys: [],
      isShowCheckPhotoDialog: false,
      imageList: [],
    }
  },
  props: {
    imageObj: {
      // 图片配置信息
      type: Object,
      default() {
        return []
      },
    },
    accept: {
      type: String,
      default() {
        return 'image/jpeg,image/jpg,image/png'
      },
    },
    acceptInfo: {
      type: String,
      default() {
        return '.jpg、.png、.jpeg'
      },
    },
    url: {
      type: String,
      default() {
        // 文件上传请求的接口
        return ''
      },
    },
    maxSize: {
      type: Number,
      default: 5,
    },
  },
  computed: {
    vehicle() {
      return this.$store.state.vehicle
    },
  },
  methods: {
    beforeUpload(file) {
      let { size, type } = file
      const { maxSize } = this
      const types = ['image/jpeg', 'image/jpg', 'image/png']
      size = size / 1024 / 1024 < maxSize
      if (!types.includes(type)) {
        this.$message.error('支持.jpg、.png、.jpeg格式')
        return false
      }
      if (!size) {
        this.$message.error(`上传图片大小不能超过 ${maxSize}MB!`)
      }
      return size
    },
    handleRemove(file, fileList) {
      this.uploadKeys = []
      this.imageList = fileList
      if (this.imageList.length < this.imageObj.limit) {
        this.$refs.uploader.$children[1].$el.style = 'display:inline-block'
      }
      this.imageList.forEach((ele) => {
        const key = ele.response ? ele.response.data.uploadKey : ele.uploadKey
        this.uploadKeys.push(key)
      })
    },
    handlePictureCardPreview(file) {
      // 点击图片放大
      this.dialogImageUrl = file.url
      this.isShowCheckPhotoDialog = true
    },
    handleSuccessPicture(res, file, fileList) {
      // 上传成功
      if (!res.errorCode) {
        this.imageList = fileList
        this.uploadKeys.push(res.data.uploadKey)
      } else {
        this.imageList = []
        fileList.forEach((item) => {
          if (item.uploadKey) {
            this.imageList.push(item)
          }
        })
        this.$message.error(res.errorMsg)
      }
      if (this.imageList.length >= this.imageObj.limit) {
        this.$refs.uploader.$children[1].$el.style = 'display:none'
      }
    },
    exceed() {
      // 文件超过限制
      this.$message({
        message: `${this.imageObj.title}最多上传${this.imageObj.limit}张`,
        type: 'error',
      })
    },
  },
}
</script>

<style lang="stylus">
@import '../../assets/css/common-color.styl'
.common-image-uploader
  margin-bottom 24px
  .el-upload--picture-card
    width 104px
    height 104px
    line-height 104px
  .el-upload-list--picture-card .el-upload-list__item
    width 104px
    height 104px
    margin-bottom 8px
  &_bottom_info
    color gray04
    font-size 14px
    margin-top 8px
  .none
    display none
  .photo_icon
    width 108px
    height 108px
    margin-top 12px
    background #F4F5F7
    display flex
    justify-content center
    align-items center
    border-radius 4px
  .title_info
    color gray02
    font-size 14px
    margin-bottom 12px
</style>
